<template>
  <font-awesome-icon :icon="['fad', 'spinner']" :size="size" spin :class="{white}"/>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';

library.add(faSpinner);

export default {
  name: 'EsLoader',
  props: {
    size: {
      type: String,
      default: '4x',
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .fa-spinner
    .fa-primary
      fill: $es-purple !important
    .fa-secondary
      fill: $es-purple-dark !important
    &.white
      .fa-primary
        fill: #FFF !important
      .fa-secondary
        fill: #FFF !important
</style>
